function fetchData(pageNumber) {
    if (isLoading) {
        return;
    }

    isLoading = true;

    const url = `${urlPaginationPart}${pageNumber}`;

    fetch(url)
        .then(response => response.text())
        .then(data => {

            const htmlString = data;
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(htmlString, 'text/html');
            const contentDiv = htmlDocument.querySelector(`.${classWithContent}`);

            console.log(contentDiv);

            document.querySelector(`.${classWithContent}`).append(contentDiv);

            isLoading = false;
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            isLoading = false;
        });
}

function scrollHandler() {
    const scrollOffset = (window.innerHeight + window.scrollY) + headerHeight;
    const contentHeight = document.querySelector('body').offsetHeight;
    //console.log(scrollOffset);
    //console.log(contentHeight);

    if (scrollOffset >= contentHeight && !isLoading && totalPages > currentPage) {
        currentPage++;
        fetchData(currentPage);
    }
}

function initInfinityScroll() {
    window.addEventListener('scroll', scrollHandler);
}
